import * as React from 'react';

const NewDocPlaceholder = () => (
  <svg width="162" height="171" viewBox="0 0 162 171" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="20.8008" width="96.2825" height="125.511" rx="12" transform="rotate(-12.1721 0 20.8008)" fill="#E1E1EB" />
    <rect
      x="29.0615"
      y="26.8086"
      width="42"
      height="6"
      rx="3"
      transform="rotate(-12.1721 29.0615 26.8086)"
      fill="#F0F0F5"
    />
    <rect
      x="26.8086"
      y="88.1738"
      width="72.2825"
      height="6"
      rx="3"
      transform="rotate(-12.1721 26.8086 88.1738)"
      fill="#F0F0F5"
    />
    <rect
      x="29.3389"
      y="99.9043"
      width="72.2825"
      height="6"
      rx="3"
      transform="rotate(-12.1721 29.3389 99.9043)"
      fill="#F0F0F5"
    />
    <rect
      x="31.8691"
      y="111.634"
      width="72.2825"
      height="6"
      rx="3"
      transform="rotate(-12.1721 31.8691 111.634)"
      fill="#F0F0F5"
    />
    <rect
      x="34.3994"
      y="123.364"
      width="72.2825"
      height="6"
      rx="3"
      transform="rotate(-12.1721 34.3994 123.364)"
      fill="#F0F0F5"
    />
    <rect
      x="67.4961"
      y="32.9639"
      width="95.6378"
      height="124.329"
      rx="12"
      transform="rotate(8.83427 67.4961 32.9639)"
      fill="#F0F0F5"
    />
    <rect
      x="92.1543"
      y="48.9404"
      width="42"
      height="6"
      rx="3"
      transform="rotate(8.83427 92.1543 48.9404)"
      fill="white"
    />
    <rect
      x="68.5527"
      y="104.302"
      width="71.6378"
      height="6"
      rx="3"
      transform="rotate(8.83427 68.5527 104.302)"
      fill="white"
    />
    <rect
      x="66.71"
      y="116.159"
      width="71.6378"
      height="6"
      rx="3"
      transform="rotate(8.83427 66.71 116.159)"
      fill="white"
    />
    <rect
      x="64.8672"
      y="128.017"
      width="71.6378"
      height="6"
      rx="3"
      transform="rotate(8.83427 64.8672 128.017)"
      fill="white"
    />
    <rect
      x="63.0244"
      y="139.875"
      width="71.6378"
      height="6"
      rx="3"
      transform="rotate(8.83427 63.0244 139.875)"
      fill="white"
    />
  </svg>
);

export default NewDocPlaceholder;
